import axios from "axios";

export default function updateAdminRole({ uuid, adminRoleUuid }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/account/system-admin/api/v1/admin/role`, {
        admin_uuid: uuid,
        role_uuid: adminRoleUuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
